'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function FormationMenu({
  identifier = 'formations-main',
  linkHome = '/',
  title = 'Formations',
}) {
  const pathname = usePathname();

  const reloadFormationMenu = () => {
    const oldScript = document.getElementById('formation-menu');
    if (oldScript) oldScript.remove();

    const script = document.createElement('script');
    script.src = 'https://statics.ffbb.app/static/js/ffbb-header-footer-v0.1.0.js';
    script.id = 'formation-menu';
    script.async = true;

    document.body.appendChild(script);
  };

  useEffect(() => {
    reloadFormationMenu();
  }, [pathname]);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://statics.ffbb.app/static/css/ffbb-header-footer-v0.1.0.css"
      />
      <div
        id="ffbb_header"
        data-config={JSON.stringify({
          identifier,
          link_home: linkHome,
          title,
        })}
        className="mx-auto w-full lg:max-w-container"
      ></div>
    </>
  );
}
